import { render } from "./VtoStickyFooter.vue?vue&type=template&id=e369d3d0"
import script from "./VtoStickyFooter.vue?vue&type=script&lang=js"
export * from "./VtoStickyFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__